import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/desembarqueAuto.scss'

import Footer from '../Footer'

export default function DesembarqueAuto() {
  return (
    <>
      <section className='desembarque-auto'>

         {/* HERO */}
        <div className='desembarque-auto-hero'>

            <div className='overlay'></div>

            <div className='container hero-content'>

                <div style={{ marginTop: '4rem' }}>
                    <Breadcrumbs />
                </div>

                <h1>Desembarque con automóvil</h1>

                <p>
                    Prepare su salida de manera segura. Siga nuestras instrucciones para una transición fluida del buque al puerto.
                </p>

            </div>

        </div>

        <div className='container'>

         
          <div className='desembarque-auto-content'>

            {/* ALERTA */}
            <div className='desembarque-auto-alert'>
              <div className='desembarque-auto-alert-icon'>
                <i className="fi fi-rs-megaphone"></i>
              </div>

              <div>
                <h3>Atención a los altavoces</h3>

                <p>
                  Minutos antes de arribar, se darán las indicaciones por audio.
                  Por favor, permanezca atento a las instrucciones generales
                  del personal.
                </p>
              </div>
            </div>

            {/* GRID PRINCIPAL */}
            <div className='desembarque-auto-grid'>

              {/* PROTOCOLO */}
              <div className='desembarque-auto-protocolo'>

                <div className='desembarque-auto-title'>
                  <i className="fi fi-rs-car-side"></i>

                  <h2>Protocolo de Desembarque</h2>
                </div>

                <p className='desembarque-auto-destacado'>
                  <strong>Conductor y sus acompañantes pueden desembarcar juntos en el vehículo.</strong>
                  {' '} Te recomendamos tener a la mano sus reservaciones y documentos del vehículo para la salida del puerto.
                  
                  
                </p>

                <div className='desembarque-auto-info'>
                  <i className="fi fi-rs-info"></i>

                  <span>
                    Esta medida agiliza el proceso aduanal y de seguridad portuaria.
                  </span>
                </div>

              </div>

              {/* TIEMPO */}
              <div className='desembarque-auto-tiempo'>

                <i class="fi fi-rs-clock-three"></i>

                <h3>Tiempo estimado</h3>

                <div className='desembarque-auto-tiempo-numero'>
                  30 - 60 <span>MIN</span>
                </div>

                

                <p>
                  Dependiendo del acomodo del vehículo y flujo portuario.
                </p>

              </div>

            </div>

            {/* TARJETAS */}
            <div className='desembarque-auto-cards'>

              {/* CARD */}
              <div className='desembarque-auto-card'>
                <i className="fi fi-rs-users"></i>

                <h4>Equipo a Bordo</h4>

                <p>
                  Siga en todo momento las instrucciones provistas por el
                  equipo de operaciones.
                </p>
              </div>

              {/* CARD */}
              <div className='desembarque-auto-card'>
                <i className="fi fi-rs-road"></i>

                <h4>Seguridad Vial</h4>

                <p>
                  Mantenga una velocidad baja y luces encendidas dentro del
                  área de carga.
                </p>
              </div>

              {/* CARD */}
              <div className='desembarque-auto-card'>
                <i className="fi fi-rs-document"></i>

                <h4>Documentación</h4>

                <p>
                  Tenga a la mano su boleto y documentos del vehículo para la
                  salida del puerto.
                </p>
              </div>

            </div>

          </div>
        </div>

        <Footer />
      </section>
    </>
  )
}